module.exports = __webpack_public_path__ + "media/images/logo_tokihana-80eb55bf89d62efaf60f75eabec5b10f.svg";